import { PLAN_BUILDER_URL } from "@/lib/clickthrough-destination";
import type { HeroOverlayType } from "@/types/monarch";

export const defaultHeroOverlayData: HeroOverlayType = {
  backgroundImages: {
    desktop: "man-on-computer-desktop.jpg",
    mobile: "man-on-computer-mobile.jpg",
  },
  title: {
    copy: "Save on the most reliable, fiber-powered WiFi",
    alignmentObject: {
      desktop: "left",
      tablet: "left",
      mobile: "center",
    },
    fontSize: "xl",
  },
  description: {
    copy: "No contract or commitment required.",
    alignment: {
      desktop: "left",
      tablet: "left",
      mobile: "center",
    },
  },
  pricing: {
    eyebrow: "Lock in 1 Gig for",
    price: "60",
    period: "5 years",
    tooltip: {
      copy: "",
    },
  },
  primaryCtaRight: {
    copy: "Shop internet",
    href: PLAN_BUILDER_URL,
    elementName: "HeroCTA",
    mobileWidth: "compact",
  },
  secondaryCtaRight: {
    copy: "Pricing & other info",
    action: "pricing-info-gig-5year",
    elementName: "HeroOverlayPricingInfo",
  },
  localizationServiceability: {
    isEnabled: false,
    elementName: "HeroOverlayServiceability",
    field: {
      inputId: "hero-overlay-serviceability-address-input",
      label: "Street address and apartment",
      placeholder: "Enter your address",
      blurFieldLabel: "Street address and apartment",
      selectFieldLabel: "Address selection",
    },
    primaryCta: {
      copy: "Check availability",
      loadingCopy: "Checking availability...",
    },
    secondaryCta: {
      copy: "Pricing & other info",
      action: "modal",
      modalKey: "pricing-info",
      elementName: "HeroOverlayServiceabilityPricing",
      display: "ghost",
    },
    statusCopy: {
      selectedAddressLabel: "Selected address",
    },
    showSelectedAddress: true,
    statusPlacement: "below",
  },
  legal: {
    copy: "<strong>Or get 300 Mbps at $45/mo for 5 years.</strong> {tooltip} Offer ends 12/1. New Xfinity Internet customers. Restrictions apply. Autopay w/ stored bank account and paperless billing req’d. Taxes and fees extra and subj. to change. Xfinity Internet is powered by fiber and connected to premises by coaxial cable. All programming subject to change and availability. Opensignal Awards USA: Fixed Broadband Experience Report, May 2025; XB6+. ",
    desktopPosition: "outsideBackground",
    tabletPosition: "outsideBackground",
    mobilePosition: "outsideBackground",
    tooltip:
      "Restrictions apply. Not available in all areas.\n\nOffer ends 12/1. New Xfinity Internet customers. Limited to 300 Mbps internet. Requires both paperless billing and automatic payments with stored bank account (or additional $10/mo charge applies). Installation, taxes and fees, and other applicable charges extra, and subj. to change. Service limited to a single outlet. Internet: Actual speeds vary and are not guaranteed. For factors affecting speed visit www.xfinity.com/networkmanagement.\n\n© 2026 Comcast. All rights reserved.",
  },
};
